import Chip from '@mui/material/Chip'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import PropTypes from 'prop-types'
import { memo } from 'react'
import { Link } from 'react-router-dom'

import ChildSpacer from '../../lib/ChildSpacer'

import reportingPaths from './reportingPaths'

const campaignTypes = [
  {
    // label: I18n.t('reporting.accelerateCampaigns'),
    label: 'Faceboook',
    value: 'facebook',
  },
  {
    // label: I18n.t('reporting.organicCampaigns'),
    label: 'Instagram',
    value: 'instagram',
  },
  {
    // label: I18n.t('reporting.organicCampaigns'),
    label: 'Twitter',
    value: 'twitter',
  },
  {
    // label: I18n.t('reporting.organicCampaigns'),
    label: 'Email',
    value: 'email',
  },
]

const ReportingTabs = ({
  value,
  campaign,
  campaignId,
  retailerAccountSlug,
  brandSlug,
}) => {
  return (
    <Tabs scrollButtons value={value} allowScrollButtonsMobile>
      {campaignTypes.map((campaignType) => (
        <Tab
          component={Link}
          to={reportingPaths.organicCampaignDetails.build({
            retailerAccountSlug,
            campaignId,
            channel: campaignType.value,
          })}
          key={campaignType.label}
          label={renderTabLabel(
            campaignType.label,
            campaignType.value,
            campaign,
          )}
          value={campaignType.value}
        />
      ))}
    </Tabs>
  )
}

function renderTabLabel(channelLabel, value, campaign) {
  let shares = campaign[value]

  //Filter out share_mode === 'mobile', we cannot get reporting for them.
  if (value === 'instagram') {
    shares = shares.filter((share) => share.share_mode === 'manual')
  }

  return (
    <span>
      <ChildSpacer size={1}>
        {channelLabel} <Chip label={shares.length} size="small" />
      </ChildSpacer>
    </span>
  )
}

ReportingTabs.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
}

export default memo(ReportingTabs)
